export default "__VITE_PUBLIC_ASSET__c73e76e9__"